import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {      
      "BetaBannerText": "Beta version — We're improving the tool. Your feedback is welcome!",
      "NutriScoreTitle": "Job-Nutriscore",
      "PMOffer": "Offer for Product Manager",
      "PMOfferSubtitle": "in Tech",
      "JobOfferLabel": "Copy and paste the job offer text (in any language)",
      "SubmitButton": "Evaluate",
      "PositionTitle": "Position:",
      "ExplanationTitle": "Explanation:",
      "ReferencesTitle": "References:",
      "aiMention" : "This score is an indicative estimate, generated by AI-based technology from the offer text.",    
      "genericError" : "Error, please try again by selecting the entire job offer description.",
      "shareError": "Share could not be analyzed. Share the full page link (not selected text), or select the entire job description before sharing.",
      "ExtractionErrorGeneric": "Extraction failed. You can copy-paste the job offer text manually.",
      "ExtractionErrorIndeed": "Indeed is not supported for web links. You can copy-paste the job offer text manually.",
      "Error_INVALID_URL": "Missing or invalid URL parameter.",
      "Error_INVALID_JOB_OFFER": "Missing or invalid job offer content.",
      "Error_MISSING_MODEL": "The 'model' parameter is required.",
      "Error_POSITION_NOT_PM_PO": "Only Product Owner and Product Manager job offers can be analyzed.",
      "Error_BUSINESS_INIT_INCOMPLETE": "The analysis could not be completed (business initiative). Please try again.",
      "Error_EXPERIMENTAL_INCOMPLETE": "The analysis could not be completed (experimental environment). Please try again.",
      "Error_FINAL_RESPONSE_INCOMPLETE": "The analysis result could not be generated. Please try again.",
      "Error_INTERNAL_ERROR": "Unexpected server error. Please try again later.",
      "URLInputLabel": "Job offer URL",
      "URLInputPlaceholder": "https://example.com/job-offer",
      "PwaShareHint": "On Android, once the app is installed, you can share job offer links directly to it.",
      "PwaShareInstallLink": "Install the app",
      "PwaShareInstallInstructions": "To install: Android — menu (⋮) then \"Install app\" or \"Add to Home screen\". iPhone — Share button then \"Add to Home Screen\".",
      "URLModeButton": "🔗 Web link",
      "TextModeButton": "📝 Manual entry",
      "AnalysisInProgress": "Analysis in progress...",
      "CompanyLabel": "Company:",
      "ResponsibleApplicationTitle": "Responsible application",
    "OurBigTechsTitle": "Our Big Techs",
      "DebugBusinessInitiativeLabel": "Special question - Debug Business Initiative (optional):",
      "DebugBusinessInitiativePlaceholder": "Enter a special question to analyze the business initiative...",
      "DebugExperimentalEnvironmentLabel": "Special question - Debug Experimental Environment (optional):",
      "DebugExperimentalEnvironmentPlaceholder": "Enter a special question to analyze the experimental environment...",
      "ModelSelectorLabel": "Model to use:",
      "AddToDatasetLabel": "Add to evaluation dataset",
      "SaveButton": "💾 Save to database",
      "Saving": "Saving...",
      "SaveSuccess": "✅ Offer saved successfully!",
      "SaveError": "❌ Error saving",
      "PrixMalbouffeVoteHere": "Junk food prize of the week, I vote here 🏆",
      "PrixMalbouffeChangeVote": "I change my vote to this one 🏆",
      "PrixMalbouffeAlreadyVoted": "You have already voted for this one 🏆",
      "PrixMalbouffeVotedThankYou": "Thank you! You can also encourage others to vote on ",
      "PrixMalbouffeShareOnLinkedIn": "LinkedIn",
      "PrixMalbouffeShareButton": "Share on LinkedIn",
      "PrixMalbouffeChangeonsCa": "Let's change that 👊",
      "PrixMalbouffeVoting": "Voting...",
      "PrixMalbouffeLink": "Junk food prize",
      "PrixMalbouffePageTitle": "🏆 Junk food prize of the week",
      "PrixMalbouffePageDescription": "The Job-Nutriscore community votes for PM job offers rated D or E that the community finds most questionable. One vote per week per user. Here are the winners.",
      "PrixMalbouffeLoading": "Loading...",
      "PrixMalbouffeError": "Error loading data",
      "PrixMalbouffeNoVotes": "No votes this week",
      "PrixMalbouffeVoteCount": "vote",
      "PrixMalbouffeVotesCount": "votes",
      "PrixMalbouffeViewOffer": "View offer",
      "PrixMalbouffeYourVote": "Your vote",
      "PrixMalbouffeUnknownCompany": "Unknown company",
      "PrixMalbouffeWeekLabel": "Week of {{date}}",
      "MetaTitlePrixMalbouffe": "Junk food prize of the week – Job-Nutriscore Product Manager",
      "MetaDescriptionPrixMalbouffe": "Discover the Job-Nutriscore community's picks for the most questionable PM job offers (D or E). Current and past winners.",
      "ScoreDetailTitle": "Score detail",
      "DebugTitle": "Debug",
      "ImproveTitle": "Improve",
      "DebugBusinessInitiativeTitle": "Debug Business Initiative",
      "DebugBusinessInitiativeSpecialTitle": "Debug Business Initiative - Special Question",
      "DebugExperimentalEnvironmentTitle": "Debug Experimental Environment",
      "DebugExperimentalEnvironmentSpecialTitle": "Debug Experimental Environment - Special Question",
      "CalculationLinkText": "learn more about the calculation",
      "NavigationHome": "Home",
      "NavigationOffers": "Offers",
      "NavigationEvals": "Evals",
      "NavigationFineTuning": "Fine-tuning",
      "NavigationAdmin": "Admin",
      "NavigationProjectionsFrance": "Projections France",
      "ProjectionsFranceTitle": "Projections France",
      "ProjectionsFranceDescription": "Estimates of losses and gains by job type (Product Manager, Product Owner).",
      "ProjectionsFranceMetier": "Job type",
      "ProjectionsFrancePerteSalaries": "Total loss (employees)",
      "ProjectionsFrancePerteEtat": "Loss (state)",
      "ProjectionsFranceGainESNs": "Gain (ESNs)",
      "ProjectionsFranceTotal": "Total",
      "ProjectionsFranceFakeNotice": "Fake values for demonstration.",
      "ProjectionsFranceHypothesesTitle": "Calculation assumptions",
      "ProjectionsFranceHypotheses80Percent": "80% of Product job offers on the market have a D or E score.",
      "ProjectionsFranceHypotheses60Percent": "60% of Product job offers are issued by intermediaries.",
      "MetaTitleHome": "Job-Nutriscore Product Manager – Evaluate PM offer quality (A to E)",
      "MetaDescriptionHome": "Job-Nutriscore Product Manager: evaluate PM job offer quality (A to E). Analysis by URL, copy-paste or share by link (Android). Company rankings. Chrome extension.",
      "MetaTitleClassement": "Company rankings – Job-Nutriscore Product Manager",
      "MetaDescriptionClassement": "Companies ranked by average Job-Nutriscore of their Product Manager job offers. Deduplicated offers. Economic loss estimates for D/E offers.",
      "ClassementLink": "Company rankings",
      "ClassementTitle": "Company rankings",
      "ClassementDescription": "Companies ranked by average Job-Nutriscore of their Product Manager job offers.",
      "ClassementDataSource": "This ranking is generated from user analyses and a France Travail scan (CAC40).",
      "ClassementDisclaimerEstimates": "The economic losses and intermediary gain displayed are indicative estimates, not certified data.",
      "ClassementCalculationLink": "Calculation details",
      "ClassementLoading": "Loading rankings...",
      "ClassementError": "Error loading rankings",
      "ClassementEmpty": "No data available yet.",
      "ClassementCompany": "Company",
      "ClassementScore": "Score",
      "ClassementOffersCount": "Offers",
      "ClassementOffersModalTitle": "Offers — {{company}}",
      "ClassementPerteSalarie": "Loss (employee)",
      "ClassementPerteEtat": "Loss (state)",
      "ClassementPerteTooltip": "Losses calculated over 10 years",
      "ClassementPerteComingSoon": "Coming...",
      "ClassementOui": "Yes",
      "ClassementNon": "No",
      "ClassementClose": "Close",
      "ClassementTotalPerteEtat": "Total state loss",
      "ClassementTotals": "Totals",
      "ClassementFilterAllCountries": "All countries",
      "ClassementFilterAllTypes": "All types",
      "ClassementPromoteResponsible": "Promotes responsible",
      "ClassementPromoteResponsibleTooltip": "On its products or services",
      "ClassementFilterCAC40": "CAC40",
      "ClassementFilterFrenchTech": "French Tech Next 40/120",
      "ClassementFrenchTechNotice": "French Tech Next40/120 is a State support program.",
      "ClassementFilterStartup": "Startup",
      "ClassementFilterTraditionalCompany": "Traditional company",
      "ClassementFilterServiceCompany": "Service company",
      "ClassementGainIntermediaire": "Gain for intermediary",
      "ClassementGainIntermediaireTooltip": "Estimated total commission earned by intermediaries, based on an average mix of freelance and permanent roles (missions and CDIs) over their typical duration.",
      "ClassementContinent_EU": "Europe",
      "ClassementContinent_NA": "North America",
      "ClassementContinent_SA": "South America",
      "ClassementContinent_AS": "Asia",
      "ClassementContinent_AF": "Africa",
      "ClassementContinent_OC": "Oceania",
      "ClassementPaginationPrev": "Previous",
      "ClassementPaginationNext": "Next",
      "ClassementPaginationPage": "Page {{current}} of {{total}}",
      "OffersTitle": "Job Offers Management",
      "OffersDescription": "View, edit and manage job offers and their associated data.",
    "OffersSelectLabel": "Select a job offer:",
    "OffersSelectPlaceholder": "-- Choose a job offer --",
    "OffersSelectedOffer": "Selected offer",
    "OffersDeleteButton": "🗑️ Delete",
    "OffersAddElement": "Add element",
    "OffersTrue": "True",
    "OffersFalse": "False",
    "OffersLoading": "Loading job offers...",
      "OffersError": "Error:",
      "OffersCompany": "Company:",
      "OffersPosition": "Position:",
      "OffersModel": "Model:",
      "OffersCreatedAt": "Created:",
    "OffersContentPreview": "Content preview:",
    "OffersEvaluationCriteria": "Evaluation criteria",
    "OffersValidationDescription": "Validate and correct the criteria and explanations below. You can edit the content directly in the fields.",
      "OffersBusinessInitiative": "Business Initiative",
      "OffersExperimentalEnvironment": "Experimental Environment",
      "OffersExplanation": "Explanation",
      "OffersScore": "Score:",
      "OffersScoreDetail": "Score Detail:",
      "OffersReferences": "References:",
      "OffersImprove": "Improve:",
      "OffersDebug": "Debug:",
      "OffersSaveButton": "💾 Save Corrections",
      "OffersSaving": "Saving...",
      "OffersSaveSuccess": "✅ Corrections saved successfully!",
      "OffersSaveError": "❌ Error saving corrections",
      "OffersDeleteConfirm": "Are you sure you want to delete this job offer? This action is irreversible.",
      "OffersBulkDeleteTitle": "Bulk Delete by Model",
      "OffersBulkDeleteDescription": "Delete all job offers for a specific model. This action is irreversible.",
      "OffersBulkDeleteSelectLabel": "Select model to delete:",
      "OffersBulkDeleteButton": "🗑️ Delete All Offers",
      "OffersBulkDeleteConfirm": "Are you sure you want to delete ALL",
      "OffersBulkDeleteConfirmEnd": "job offers for the model",
      "OffersBulkDeleteConfirmWarning": "? This action is irreversible and will also delete all associated data (analyses, criteria, explanations).",
    "OffersBulkDeleteSuccess": "✅ All",
    "OffersBulkDeleteSuccessEnd": "offers for the model",
    "OffersBulkDeleteSuccessEnd2": "have been successfully deleted.",
    "OffersNoOffersFound": "No job offers found for the model",
    "OffersMoveUp": "Move up",
    "OffersMoveDown": "Move down",
    "OffersRemoveElement": "Remove this element",
    "OffersDebugSpecialQuestionPlaceholder": "Enter content for Debug Special Question...",
    "OffersPositionLabel": "Position:",
    "OffersPositionPlaceholder": "Job title",
    "OffersCompanyLabel": "Company:",
    "OffersCompanyPlaceholder": "Company name",
    "OffersExplanationLabel": "Explanation:",
    "OffersExplanationPlaceholder": "Analysis explanation",
    "OffersReferencesLabel": "References:",
    "OffersReferencesPlaceholder": "HTML references",
    "OffersDebugInfoPlaceholder": "Debug information",
    "OffersAnalysisResults": "Analysis results",
    "OffersNutriScoreCalculated": "NutriScore (calculated):",
    "OffersScoreDetailCalculated": "Score detail (calculated):",
    "OffersGlobalEvaluation": "Global Evaluation",
      "EvalsTitle": "Administration",
      "EvalsDatasetTitle": "Dataset Generation (Evals)",
      "EvalsDatasetDescription": "Create a JSONL file in OpenAI Evals format containing all job offers with their corrected criteria. This dataset will be automatically sent to OpenAI for evaluation and can be used with the Evals API.",
      "EvalsModelSelectorLabel": "Offers with the model:",
      "EvalsModelSelectPlaceholder": "-- Choose a model --",
      "EvalsCreateDatasetButton": "📊 Create and Send Dataset",
      "EvalsGenerating": "🔄 Generation in progress...",
      "EvalsLaunchTitle": "Launch Evals",
      "EvalsLaunchDescription": "Select a dataset and launch an evaluation to test the maturity criteria of job offers.",
      "EvalsDatasetSelectLabel": "Select a dataset:",
      "EvalsDatasetSelectPlaceholder": "-- Choose a dataset --",
      "EvalsCheckboxesLabel": "Types of evaluation to launch:",
      "EvalsBusinessInitiativesCheckbox": "Business Initiative Detection",
      "EvalsExperimentalEnvironmentCheckbox": "Experimental Environment Detection",
      "EvalsExplanationsCheckbox": "Score Explanation",
      "EvalsTestModelLabel": "Model to test against:",
      "EvalsTestModelPlaceholder": "-- Choose a model --",
      "EvalsLaunchButton": "🚀 Launch Evals",
    "EvalsRunning": "🔄 Evaluation in progress...",
    "EvalsDatasetCreatedSuccess": "Dataset created successfully!",
    "EvalsEntriesProcessed": "entries processed",
    "EvalsDatasetCreationError": "Error creating dataset:",
    "EvalsSelectDatasetMessage": "Please select a dataset to evaluate.",
    "EvalsSelectEvaluationMessage": "Please check at least one evaluation to launch.",
    "EvalsSelectTestModelMessage": "Please select a model to test.",
    "EvalsNoDatasets": "No datasets available. Create a dataset first.",
      "EvalsDeleteTitle": "Dataset Deletion",
      "EvalsDeleteDescription": "Select a dataset to permanently delete. This action is irreversible.",
      "EvalsDeleteSelectLabel": "Select a dataset to delete:",
      "EvalsDeleteSelectPlaceholder": "-- Choose a dataset --",
      "EvalsDeleteButton": "🗑️ Delete Dataset",
      "EvalsDeleting": "🔄 Deletion...",
      "EvalsNoDatasetsDelete": "No datasets available to delete.",
      "FineTuningTitle": "Fine-tuning",
      "FineTuningRefreshButton": "🔄 Refresh",
      "FineTuningDatasetTitle": "Dataset Generation (Fine-tuning)",
      "FineTuningDatasetDescription": "Create a fine-tuning dataset from corrected job offers.",
      "FineTuningModelSelectorLabel": "Offers with the model:",
      "FineTuningModelSelectPlaceholder": "-- Choose a model --",
      "FineTuningCreateDatasetButton": "📊 Create Dataset",
    "FineTuningGenerating": "🔄 Generation in progress...",
    "FineTuningSelectOptionMessage": "Please select at least one option to create the dataset.",
    "FineTuningNoOffers": "No job offers found for the selected model.",
    "FineTuningSuccess": "Dataset created successfully!",
    "FineTuningLoading": "Loading...",
    "FineTuningError": "Error",
    "FineTuningRetry": "🔄 Retry",
    "FineTuningOptionsLabel": "Options to include in the dataset:",
    "FineTuningBusinessInitiativeCheckbox": "Business initiative level detection",
    "FineTuningExperimentalEnvironmentCheckbox": "Experimental environment level detection",
    "FineTuningExplanationCheckbox": "Score explanation",
    "FineTuningModelTitle": "Model Fine-Tuning",
    "FineTuningNoDatasets": "No fine-tuning datasets available. Create a dataset first.",
    "FineTuningDeleteTitle": "Dataset Deletion (Fine-tuning)",
    "FineTuningNoDatasetsDelete": "No fine-tuning datasets available to delete.",
    "OffersNotDefined": "Not defined",
    "OffersAppreciation": "Appreciation:",
    "OffersEvaluation": "Evaluation:",
    "OffersDeletingCorrections": "Deleting corrections in progress...",
    "OffersNoModelsAvailable": "No models available. No job offers found.",
    "NoDetailsAvailable": "No details available",
    "BusinessInitiative": "Business Initiative",
    "Score": "Score",
    "Appreciation": "Appreciation",
    "Explanation": "Explanation",
    "NotDefined": "Not defined",
    "ExperimentalEnvironment": "Experimental Environment",
    "GlobalEvaluation": "Global Evaluation",
    "Evaluation": "Evaluation",
    "References": "References",
    "AuthenticationVerification": "Authentication verification...",
    "OffersImprovementSuggestions": "Improvement suggestions",
    "OffersNoDetails": "No details available",
    "OffersDetailsNotCalculated": "Details not calculated",
    "OffersNotCalculated": "Not calculated",
    "OffersDeleting": "Deleting...",
    "OffersDeleteCorrectionsButton": "🗑️ Delete corrections",
    "OffersBulkDeleteProgress": "Deleting {{count}} offers in progress...",
    "OffersBulkDeleteSelectPlaceholder": "-- Choose a model --",
    "OffersNegativeIndicators": "Negative Indicators",
    "OffersSaveCorrectionsButton": "💾 Save corrections",
    "OffersAddDebugInfo": "Add debug information",
    "OffersBusinessModelDefinition": "Business model definition",
    "OffersProductVision": "Product vision",
    "OffersProductStrategyDefinition": "Product strategy definition",
    "OffersProductMarketingActivities": "Product marketing activities",
    "OffersGrowthActivities": "Growth activities",
    "OffersUserExperienceActivities": "User experience activities",
    "OffersDeliveryActivities": "Delivery activities",
    "OffersDeliveryListedBeforeTacticsAndStrategy": "Delivery listed before tactics/strategy",
    "OffersFeatureTeam": "Feature/marketing team",
    "OffersTitleIsProductOwner": "Title is Product Owner",
    "OffersProductManagerWorksWithDistinctProductOwner": "PM with distinct PO",
    "OffersUsesSAFe": "Uses SAFe",
    "OffersCollaboratesWithDistinctBusinessTeam": "Collaborates with distinct business team",
    "OffersProductMarketingCustomerDiscovery": "Customer discovery (Product Marketing)",
    "OffersGrowthMarketingCustomerDiscovery": "Customer discovery (Growth)",
    "OffersUXCustomerDiscovery": "Customer discovery (UX)",
    "OffersContinuousDelivery": "Continuous delivery",
    "OffersInternalProduct": "Internal product",
    "OffersStrategicResponsibilities": "Strategic Responsibilities",
    "OffersTacticalAccountabilities": "Tactical Accountabilities",
    "FineTuningLaunchDescription": "Select a fine-tuning dataset and launch training for a new custom model. The process can take several hours depending on the dataset size.",
    "FineTuningSelectDatasetLabel": "Select a dataset:",
    "FineTuningLaunchButton": "🚀 Launch Fine-Tuning",
    "FineTuningLaunching": "🔄 Launching...",
    "FineTuningDeleteDescription": "Select a fine-tuning dataset to permanently delete. This action is irreversible.",
    "FineTuningDeleteSelectLabel": "Select a dataset to delete:",
    "FineTuningSelectDatasetMessage": "Please select a dataset for fine-tuning.",
    "FineTuningLaunchingMessage": "Fine-tuning launch in progress...",
    "FineTuningDatasetSelectPlaceholder": "-- Choose a dataset --",
    "FineTuningDeleteButton": "🗑️ Delete Dataset",
    "FineTuningDeleting": "🔄 Deleting...",
    "AuthEmailPrompt": "Please provide your email to confirm the connection:",
    "AuthLinkSentMessage": "Connection link sent! Check your email.",
    "AuthSending": "Sending...",
    "AuthConnectButton": "Connect",
"AuthEmailPlaceholder": "Your email",
      "PrivacyPolicyLink": "Privacy policy",
      "LegalNoticeLink": "Legal notice",
      "TermsOfServiceLink": "Terms of service",
      "FaqLink": "FAQ",
      "AboutLink": "About",
      "ExtensionChromeLink": "Chrome extension",
      "ResponsibleApplicationDirectLossCandidate": "This partially compliant offer costs the candidate between €160,000 and €400,000+ over 10 years",
    "ResponsibleApplicationDirectLossDetails": "in salary losses, missed promotions, wasted training investments, and career progression delays.",
    "ResponsibleApplicationDirectLossState": "The State loses approximately €985,000",
    "ResponsibleApplicationDirectLossStateDetails": "in direct support, lost tax revenue, wasted training subsidies, and social costs per startup.",
    "ResponsibleApplicationGeneralLossCandidate": "A partially compliant Product Manager offer can cost candidates €160,000 to €400,000+ over 10 years",
    "ResponsibleApplicationGeneralLossDetails": "through salary gaps, blocked career progression, and wasted training investments.",
    "ResponsibleApplicationGeneralLossState": "The State can lose up to €985,000 per startup",
    "ResponsibleApplicationGeneralLossStateDetails": "in public support, tax losses, training waste, and reduced economic productivity.",
    "OurBigTechsContent": "The innovation job market has become a bidding fair where modern titles (Product Manager, UX Designer, etc.) often hide traditional roles (Project Manager, UI Designer, etc.). This affects European workers, companies, and citizens. We demand standardization of innovation professions, company ratings, adjustment of public aid, and sanctions for partially compliant companies.",
    "OurBigTechsLinkText": "Like the article on LinkedIn",
    "CalcNotDefined": "Not defined",
    "CalcNoMention": "No mention",
    "CalcConsulted": "Consulted",
    "CalcResponsibleExecutes": "Responsible (executes)",
    "CalcAccountableDecides": "Accountable (decides)",
    "CalcAccountableNotExecutes": "Accountable (decides but does not execute)",
    "CalcResponsibleNotDecides": "Responsible (executes but does not decide)",
    "CalcAccountableAndResponsible": "Accountable and responsible (decides and executes)",
    "CalcCollaboratesWithProductMarketer": "Collaborates directly with a Product Marketer",
    "CalcAccountableWithProductMarketer": "Accountable (decides) and collaborates directly with a Product Marketer",
    "CalcCollaboratesWithGrowthManager": "Collaborates directly with a Growth Manager",
    "CalcAccountableWithGrowthManager": "Accountable (decides) and collaborates directly with a Growth Manager",
    "CalcCollaboratesWithUXDesigner": "Accountable (decides) and collaborates with a UX Designer",
    "CalcUnknownValue": "Unknown value ({{value}})",
    "CalcStrategicResponsibilities": "Strategic responsibilities",
    "CalcTacticalAccountabilities": "Tactical accountabilities",
    "CalcBusinessModelDefinition": "Business model definition:",
    "CalcProductStrategyDefinition": "Product strategy definition:",
    "CalcProductMarketingActivities": "Product marketing activities:",
    "CalcGrowthActivities": "Growth marketing activities:",
    "CalcUXActivities": "UX activities:",
    "CalcDeliveryActivities": "Delivery activities:",
    "CalcNegativeIndicators": "Negative indicators",
    "CalcNone": "None",
    "CalcNoData": "No data",
    "CalcCustomerDiscoveryActivities": "Customer discovery activities",
    "CalcProductMarketingDiscovery": "Customer discovery in product marketing:",
    "CalcGrowthMarketingDiscovery": "Customer discovery in growth marketing:",
    "CalcUXDiscovery": "Customer discovery in UX:",
    "CalcContinuousDelivery": "Continuous delivery:",
    "CalcMentionedPositioning": "Mentioned",
    "CalcMentionedAcquisition": "Mentioned",
    "CalcMentionedUX": "Mentioned",
    "CalcMentionedFrequent": "Mentioned",
    "CalcNotMentioned": "Not mentioned",
    "CalcFinalScore": "Final score",
    "CalcWeighting": "Weighting:",
    "CalcNutriScoreScore": "Job-Nutriscore:",
    "CalcSmellDeliveryListedFirst": "Delivery activities are listed before tactics and strategy",
    "CalcSmellFeatureTeam": "The Product Manager is responsible for a feature or aspect of the product, not the full product",
    "CalcSmellTitleProductOwner": "Job title is Product Owner instead of Product Manager",
    "CalcSmellPMWithDistinctPO": "The Product Manager works with a distinct Product Owner",
    "CalcSmellUsesSAFe": "The organization uses SAFe methodology",
    "CalcSmellDistinctBusinessTeam": "Collaboration with a distinct business team or Business Owner",
    "CalcSmellUserNeedsOverValue": "Goal is user needs satisfaction without mention of economic value",
    "CalcSmellManageMultipleProducts": "The Product Manager manages multiple products",
    "CalcSmellNoDistinctUXDesigner": "No distinct UX Designer explicitly mentioned",
    "CalcSmellUXOptimization": "Focus on UX optimization rather than customer discovery and experimentation",
    "CalcSmellProductMarketingOptimization": "Focus on product marketing optimization rather than customer discovery and experimentation",
    "CalcSmellGrowthOptimization": "Focus on growth marketing optimization rather than customer discovery and experimentation",
    "CalcSmellFeatureDeliverySpeed": "Priority on feature delivery speed over business value",
    "CalcSmellInternalProduct": "All products are internal rather than customer-facing",
    "CalcDetailsTitle": "Calculation criteria",
    "CalcTooltipBusinessModelDefinition": "Expected: The PM defines or significantly influences the business model.\nLevels: not mentioned, consulted, responsible (executes), accountable (decides).",
    "CalcTooltipProductStrategyDefinition": "Expected: The PM defines or significantly influences product strategy.\nLevels: not mentioned, consulted, responsible (executes), accountable (decides).",
    "CalcTooltipProductMarketingActivities": "Expected: Activities including market analysis, positioning, go-to-market.\nLevels: not mentioned, collaborates with a Product Marketer, accountable and collaborates.",
    "CalcTooltipGrowthActivities": "Expected: Activities related to user acquisition, channel testing.\nLevels: not mentioned, collaborates with a Growth Manager, accountable and collaborates.",
    "CalcTooltipUXActivities": "Expected: User research, UX design, prototyping.\nLevels: not mentioned, accountable and collaborates with a UX Designer.",
    "CalcTooltipDeliveryActivities": "Expected: Product vision, product strategy, backlog management, user stories.\nLevels: not mentioned, accountable (decides), responsible (executes), accountable and responsible.",
    }
  },
  fr: {
    translation: {
      "BetaBannerText": "Version bêta — Nous améliorons l'outil. Vos retours sont les bienvenus !",
      "NutriScoreTitle": "Job-Nutriscore",
      "PMOffer": "Offre de Product Manager",
      "PMOfferSubtitle": "dans la Tech",
      "JobOfferLabel": "Copiez-collez le texte de l'offre d'emploi (dans n'importe quelle langue)",
      "SubmitButton": "Évaluer",
      "PositionTitle": "Poste :",
      "ExplanationTitle": "Explication :",
      "ReferencesTitle": "Références",
      "aiMention" : "Ce score est une estimation à titre informatif, générée par une technologie basée sur l'IA à partir du texte de l'offre.",
      "genericError" : "Erreur, veuillez réessayer en sélectionnant l'intégralité du descriptif de l'offre d'emploi.",
      "shareError": "Le partage n'a pas pu être analysé. Partagez le lien complet de la page (et non du texte sélectionné), ou sélectionnez l'intégralité du descriptif avant de partager.",
      "ExtractionErrorGeneric": "L'extraction a échoué. Vous pouvez copier-coller le texte de l'offre manuellement.",
      "ExtractionErrorIndeed": "Indeed n'est pas supporté en lien web. Vous pouvez copier-coller le texte de l'offre manuellement.",
      "Error_INVALID_URL": "Paramètre d’URL manquant ou invalide.",
      "Error_INVALID_JOB_OFFER": "Texte de l’offre manquant ou invalide.",
      "Error_MISSING_MODEL": "Le paramètre « model » est requis.",
      "Error_POSITION_NOT_PM_PO": "Seules les offres de Product Owner et Product Manager sont analysables.",
      "Error_BUSINESS_INIT_INCOMPLETE": "L’analyse n’a pas pu être terminée (initiative business). Merci de réessayer.",
      "Error_EXPERIMENTAL_INCOMPLETE": "L’analyse n’a pas pu être terminée (environnement expérimental). Merci de réessayer.",
      "Error_FINAL_RESPONSE_INCOMPLETE": "Le résultat d’analyse n’a pas pu être généré. Merci de réessayer.",
      "Error_INTERNAL_ERROR": "Erreur serveur inattendue. Merci de réessayer plus tard.",
      "URLInputLabel": "URL de l'offre d'emploi",
      "URLInputPlaceholder": "https://exemple.com/offre-emploi",
      "PwaShareHint": "Sur Android, une fois l'app installée, vous pouvez partager les liens d'offre directement.",
      "PwaShareInstallLink": "Installer l'app",
      "PwaShareInstallInstructions": "Pour installer : Android — menu (⋮) puis « Installer l'application » ou « Ajouter à l'écran d'accueil ». iPhone — bouton Partager puis « Sur l'écran d'accueil ».",
      "URLModeButton": "🔗 Lien web",
      "TextModeButton": "📝 Saisie manuelle",
      "AnalysisInProgress": "Analyse en cours...",
      "CompanyLabel": "Entreprise :",
      "ResponsibleApplicationTitle": "Candidature responsable",
    "OurBigTechsTitle": "Our Big Techs",
      "DebugBusinessInitiativeLabel": "Question spéciale - Debug Business Initiative (optionnel) :",
      "DebugBusinessInitiativePlaceholder": "Saisissez une question spéciale pour analyser l'initiative business...",
      "DebugExperimentalEnvironmentLabel": "Question spéciale - Debug Environnement Expérimental (optionnel) :",
      "DebugExperimentalEnvironmentPlaceholder": "Saisissez une question spéciale pour analyser l'environnement expérimental...",
      "ModelSelectorLabel": "Modèle à utiliser :",
      "AddToDatasetLabel": "Ajouter à l'ensemble de données d'évaluation",
      "SaveButton": "💾 Sauvegarder en base",
      "Saving": "Sauvegarde...",
      "SaveSuccess": "✅ Offre sauvegardée avec succès !",
      "SaveError": "❌ Erreur lors de la sauvegarde",
      "PrixMalbouffeVoteHere": "Prix malbouffe de la semaine, je vote ici 🏆",
      "PrixMalbouffeChangeVote": "Je change mon vote pour celle-ci 🏆",
      "PrixMalbouffeAlreadyVoted": "Vous avez déjà voté pour celle-ci 🏆",
      "PrixMalbouffeVotedThankYou": "Merci ! Tu peux aussi encourager à voter sur ",
      "PrixMalbouffeShareOnLinkedIn": "LinkedIn",
      "PrixMalbouffeShareButton": "Partager sur LinkedIn",
      "PrixMalbouffeChangeonsCa": "Changeons ça 👊",
      "PrixMalbouffeVoting": "Vote en cours...",
      "PrixMalbouffeLink": "Prix malbouffe",
      "PrixMalbouffePageTitle": "🏆 Prix malbouffe de la semaine",
      "PrixMalbouffePageDescription": "La communauté Job-Nutriscore vote pour les offres PM notées D ou E les plus discutables selon la communauté. Un vote par semaine par utilisateur. Voici les vainqueurs.",
      "PrixMalbouffeLoading": "Chargement...",
      "PrixMalbouffeError": "Erreur lors du chargement",
      "PrixMalbouffeNoVotes": "Aucun vote cette semaine",
      "PrixMalbouffeVoteCount": "vote",
      "PrixMalbouffeVotesCount": "votes",
      "PrixMalbouffeViewOffer": "Voir l'offre",
      "PrixMalbouffeYourVote": "Votre vote",
      "PrixMalbouffeUnknownCompany": "Entreprise inconnue",
      "PrixMalbouffeWeekLabel": "Semaine du {{date}}",
      "MetaTitlePrixMalbouffe": "Prix malbouffe de la semaine – Job-Nutriscore Product Manager",
      "MetaDescriptionPrixMalbouffe": "Découvrez les offres PM jugées les plus discutables (D ou E) par la communauté Job-Nutriscore. Vainqueurs actuels et passés.",
      "ScoreDetailTitle": "Score détail",
      "DebugTitle": "Debug",
      "ImproveTitle": "Improve",
      "DebugBusinessInitiativeTitle": "Debug Business Initiative",
      "DebugBusinessInitiativeSpecialTitle": "Debug Business Initiative - Question Spéciale",
      "DebugExperimentalEnvironmentTitle": "Debug Environnement Expérimental",
      "DebugExperimentalEnvironmentSpecialTitle": "Debug Environnement Expérimental - Question Spéciale",
      "CalculationLinkText": "en savoir plus sur le calcul",
      "NavigationHome": "Accueil",
      "NavigationOffers": "Offres",
      "NavigationEvals": "Evals",
      "NavigationFineTuning": "Fine-tuning",
      "NavigationAdmin": "Admin",
      "NavigationProjectionsFrance": "Projections France",
      "ProjectionsFranceTitle": "Projections France",
      "ProjectionsFranceDescription": "Estimations des pertes et gains par métier (Product Manager, Product Owner).",
      "ProjectionsFranceMetier": "Métier",
      "ProjectionsFrancePerteSalaries": "Perte totale (salariés)",
      "ProjectionsFrancePerteEtat": "Perte (état)",
      "ProjectionsFranceGainESNs": "Gain (ESNs)",
      "ProjectionsFranceTotal": "Total",
      "ProjectionsFranceFakeNotice": "Valeurs factices pour la démonstration.",
      "ProjectionsFranceHypothesesTitle": "Hypothèses de calcul",
      "ProjectionsFranceHypotheses80Percent": "80 % des offres Produits proposées sur le marché ont un score de D ou E.",
      "ProjectionsFranceHypotheses60Percent": "60 % des offres Produits sont émises par des intermédiaires.",
      "MetaTitleHome": "Job-Nutriscore Product Manager – Évaluez la qualité des offres PM (A à E)",
      "MetaDescriptionHome": "Job-Nutriscore Product Manager : évaluez la qualité des offres PM (score A à E). Analyse par URL, copier-coller ou partage par lien (Android). Classement des entreprises. Extension Chrome.",
      "MetaTitleClassement": "Classement des entreprises – Job-Nutriscore Product Manager",
      "MetaDescriptionClassement": "Entreprises classées selon la note moyenne Job-Nutriscore de leurs offres Product Manager. Offres dédupliquées. Estimations de pertes économiques pour les offres D/E.",
      "ClassementLink": "Classement des entreprises",
      "ClassementTitle": "Classement des entreprises",
      "ClassementDescription": "Entreprises classées selon la note moyenne Job-Nutriscore de leurs offres Product Manager.",
      "ClassementDataSource": "Ce classement est généré à partir des analyses des utilisateurs et d'un scan France Travail (CAC40).",
      "ClassementDisclaimerEstimates": "Les pertes économiques et le gain intermédiaire affichés sont des estimations indicatives, non des données certifiées.",
      "ClassementCalculationLink": "Détail du calcul",
      "ClassementLoading": "Chargement du classement...",
      "ClassementError": "Erreur lors du chargement du classement",
      "ClassementEmpty": "Aucune donnée disponible pour le moment.",
      "ClassementCompany": "Entreprise",
      "ClassementScore": "Note",
      "ClassementOffersCount": "Offres",
      "ClassementOffersModalTitle": "Offres — {{company}}",
      "ClassementPerteSalarie": "Perte pour le salarié",
      "ClassementPerteEtat": "Perte pour l'état",
      "ClassementPerteTooltip": "Pertes calculées sur 10 ans",
      "ClassementPerteComingSoon": "À venir...",
      "ClassementOui": "Oui",
      "ClassementNon": "Non",
      "ClassementClose": "Fermer",
      "ClassementTotalPerteEtat": "Total perte état",
      "ClassementTotals": "Totaux",
      "ClassementFilterAllCountries": "Tous pays",
      "ClassementFilterAllTypes": "Tous types",
      "ClassementPromoteResponsible": "Promeut le responsable",
      "ClassementPromoteResponsibleTooltip": "Sur ses produits ou services",
      "ClassementFilterCAC40": "CAC40",
      "ClassementFilterFrenchTech": "French Tech Next 40/120",
      "ClassementFrenchTechNotice": "Le French Tech Next40/120 est un programme d'accompagnement de l'État.",
      "ClassementFilterStartup": "Startup",
      "ClassementFilterTraditionalCompany": "Entreprise traditionnelle",
      "ClassementFilterServiceCompany": "Société de services",
      "ClassementGainIntermediaire": "Gain pour l’intermédiaire",
      "ClassementGainIntermediaireTooltip": "Commission totale estimée gagnée par les intermédiaires, basée sur un mix moyen de missions freelance et de CDI sur leur durée typique.",
      "ClassementContinent_EU": "Europe",
      "ClassementContinent_NA": "Amérique du Nord",
      "ClassementContinent_SA": "Amérique du Sud",
      "ClassementContinent_AS": "Asie",
      "ClassementContinent_AF": "Afrique",
      "ClassementContinent_OC": "Océanie",
      "ClassementPaginationPrev": "Précédent",
      "ClassementPaginationNext": "Suivant",
      "ClassementPaginationPage": "Page {{current}} sur {{total}}",
      "OffersTitle": "Gestion des Offres d'Emploi",
      "OffersDescription": "Visualisez, modifiez et gérez les offres d'emploi et leurs données associées.",
    "OffersSelectLabel": "Sélectionner une offre d'emploi :",
    "OffersSelectPlaceholder": "-- Choisir une offre d'emploi --",
    "OffersSelectedOffer": "Offre sélectionnée",
    "OffersDeleteButton": "🗑️ Supprimer",
    "OffersAddElement": "Ajouter un élément",
    "OffersTrue": "Vrai",
    "OffersFalse": "Faux",
    "OffersLoading": "Chargement des offres d'emploi...",
      "OffersError": "Erreur :",
      "OffersCompany": "Entreprise :",
      "OffersPosition": "Poste :",
      "OffersModel": "Modèle :",
      "OffersCreatedAt": "Créé le :",
    "OffersContentPreview": "Aperçu du contenu :",
    "OffersEvaluationCriteria": "Critères d'évaluation",
    "OffersValidationDescription": "Validez et corrigez les critères et explications ci-dessous. Vous pouvez modifier le contenu directement dans les champs.",
      "OffersBusinessInitiative": "Initiative Business",
      "OffersExperimentalEnvironment": "Environnement Expérimental",
      "OffersExplanation": "Explication",
      "OffersScore": "Score :",
      "OffersScoreDetail": "Détail du Score :",
      "OffersReferences": "Références :",
      "OffersImprove": "Améliorer :",
      "OffersDebug": "Debug :",
      "OffersSaveButton": "💾 Sauvegarder les Corrections",
      "OffersSaving": "Sauvegarde...",
      "OffersSaveSuccess": "✅ Corrections sauvegardées avec succès !",
      "OffersSaveError": "❌ Erreur lors de la sauvegarde des corrections",
      "OffersDeleteConfirm": "Êtes-vous sûr de vouloir supprimer cette offre d'emploi ? Cette action est irréversible.",
      "OffersBulkDeleteTitle": "Suppression en Masse par Modèle",
      "OffersBulkDeleteDescription": "Supprimer toutes les offres d'emploi pour un modèle spécifique. Cette action est irréversible.",
      "OffersBulkDeleteSelectLabel": "Sélectionner le modèle à supprimer :",
      "OffersBulkDeleteButton": "🗑️ Supprimer Toutes les Offres",
      "OffersBulkDeleteConfirm": "Êtes-vous sûr de vouloir supprimer TOUTES les",
      "OffersBulkDeleteConfirmEnd": "offres d'emploi du modèle",
      "OffersBulkDeleteConfirmWarning": " ? Cette action est irréversible et supprimera également toutes les données associées (analyses, critères, explications).",
    "OffersBulkDeleteSuccess": "✅ Toutes les",
    "OffersBulkDeleteSuccessEnd": "offres du modèle",
    "OffersBulkDeleteSuccessEnd2": "ont été supprimées avec succès.",
    "OffersNoOffersFound": "Aucune offre d'emploi trouvée pour le modèle",
    "OffersMoveUp": "Déplacer vers le haut",
    "OffersMoveDown": "Déplacer vers le bas",
    "OffersRemoveElement": "Supprimer cet élément",
    "OffersDebugSpecialQuestionPlaceholder": "Saisissez le contenu pour Debug Special Question...",
    "OffersPositionLabel": "Poste :",
    "OffersPositionPlaceholder": "Titre du poste",
    "OffersCompanyLabel": "Entreprise :",
    "OffersCompanyPlaceholder": "Nom de l'entreprise",
    "OffersExplanationLabel": "Explication :",
    "OffersExplanationPlaceholder": "Explication de l'analyse",
    "OffersReferencesLabel": "Références :",
    "OffersReferencesPlaceholder": "Références HTML",
    "OffersDebugInfoPlaceholder": "Information de debug",
    "OffersAnalysisResults": "Résultats de l'analyse",
    "OffersNutriScoreCalculated": "NutriScore (calculé) :",
    "OffersScoreDetailCalculated": "Détail du score (calculé) :",
    "OffersGlobalEvaluation": "Évaluation Globale",
      "EvalsTitle": "Administration",
      "EvalsDatasetTitle": "Génération de Dataset (Evals)",
      "EvalsDatasetDescription": "Créez un fichier JSONL au format OpenAI Evals contenant toutes les offres d'emploi avec leurs critères corrigés. Ce dataset sera automatiquement envoyé vers OpenAI pour l'évaluation et pourra être utilisé avec l'API Evals.",
      "EvalsModelSelectorLabel": "Offres avec le modèle :",
      "EvalsModelSelectPlaceholder": "-- Choisir un modèle --",
      "EvalsCreateDatasetButton": "📊 Créer et Envoyer Dataset",
      "EvalsGenerating": "🔄 Génération en cours...",
      "EvalsLaunchTitle": "Lancement d'Evals",
      "EvalsLaunchDescription": "Sélectionnez un dataset et lancez une évaluation pour tester les critères de maturité des offres d'emploi.",
      "EvalsDatasetSelectLabel": "Sélectionner un dataset :",
      "EvalsDatasetSelectPlaceholder": "-- Choisir un dataset --",
      "EvalsCheckboxesLabel": "Types d'évaluation à lancer :",
      "EvalsBusinessInitiativesCheckbox": "Détection Business Initiative",
      "EvalsExperimentalEnvironmentCheckbox": "Détection Environnement Expérimental",
      "EvalsExplanationsCheckbox": "Score Explanation",
      "EvalsTestModelLabel": "Modèle à tester contre :",
      "EvalsTestModelPlaceholder": "-- Choisir un modèle --",
      "EvalsLaunchButton": "🚀 Lancer l'Evals",
    "EvalsRunning": "🔄 Évaluation en cours...",
    "EvalsDatasetCreatedSuccess": "Dataset créé avec succès !",
    "EvalsEntriesProcessed": "entrées traitées",
    "EvalsDatasetCreationError": "Erreur lors de la création du dataset :",
    "EvalsSelectDatasetMessage": "Veuillez sélectionner un dataset à évaluer.",
    "EvalsSelectEvaluationMessage": "Veuillez cocher au moins une évaluation à lancer.",
    "EvalsSelectTestModelMessage": "Veuillez sélectionner un modèle à tester.",
    "EvalsNoDatasets": "Aucun dataset disponible. Créez d'abord un dataset.",
      "EvalsDeleteTitle": "Suppression de Dataset",
      "EvalsDeleteDescription": "Sélectionnez un dataset à supprimer définitivement. Cette action est irréversible.",
      "EvalsDeleteSelectLabel": "Sélectionner un dataset à supprimer :",
      "EvalsDeleteSelectPlaceholder": "-- Choisir un dataset --",
      "EvalsDeleteButton": "🗑️ Supprimer Dataset",
      "EvalsDeleting": "🔄 Suppression...",
      "EvalsNoDatasetsDelete": "Aucun dataset disponible à supprimer.",
      "FineTuningTitle": "Fine-tuning",
      "FineTuningRefreshButton": "🔄 Actualiser",
      "FineTuningDatasetTitle": "Génération de Dataset (Fine-tuning)",
      "FineTuningDatasetDescription": "Créez un dataset de fine-tuning à partir des offres d'emploi corrigées.",
      "FineTuningModelSelectorLabel": "Offres avec le modèle :",
      "FineTuningModelSelectPlaceholder": "-- Choisir un modèle --",
      "FineTuningCreateDatasetButton": "📊 Créer Dataset",
    "FineTuningGenerating": "🔄 Génération en cours...",
    "FineTuningSelectOptionMessage": "Veuillez sélectionner au moins une option pour créer le dataset.",
    "FineTuningNoOffers": "Aucune offre d'emploi trouvée pour le modèle sélectionné.",
    "FineTuningSuccess": "Dataset créé avec succès !",
    "FineTuningLoading": "Chargement...",
    "FineTuningError": "Erreur",
    "FineTuningRetry": "🔄 Réessayer",
    "FineTuningOptionsLabel": "Options à inclure dans le dataset :",
    "FineTuningBusinessInitiativeCheckbox": "Détection du niveau de business initiative",
    "FineTuningExperimentalEnvironmentCheckbox": "Détection du niveau environnement expérimental",
    "FineTuningExplanationCheckbox": "Explication de la note",
    "FineTuningModelTitle": "Fine-Tuning de modèle",
    "FineTuningNoDatasets": "Aucun dataset de fine-tuning disponible. Créez d'abord un dataset.",
    "FineTuningDeleteTitle": "Suppression de Dataset (Fine-tuning)",
    "FineTuningNoDatasetsDelete": "Aucun dataset de fine-tuning disponible à supprimer.",
    "OffersNotDefined": "Non défini",
    "OffersAppreciation": "Appréciation :",
    "OffersEvaluation": "Évaluation :",
    "OffersDeletingCorrections": "Suppression des corrections en cours...",
    "OffersNoModelsAvailable": "Aucun modèle disponible. Aucune offre d'emploi trouvée.",
    "NoDetailsAvailable": "Aucun détail disponible",
    "BusinessInitiative": "Initiative business",
    "Score": "Score",
    "Appreciation": "Appréciation",
    "Explanation": "Explication",
    "NotDefined": "Non défini",
    "ExperimentalEnvironment": "Environnement Expérimental",
    "GlobalEvaluation": "Évaluation Globale",
    "Evaluation": "Évaluation",
    "References": "Références",
    "AuthenticationVerification": "Vérification de l'authentification...",
    "OffersImprovementSuggestions": "Suggestions d'amélioration",
    "OffersNoDetails": "Aucun détail disponible",
    "OffersDetailsNotCalculated": "Détails non calculés",
    "OffersNotCalculated": "Non calculé",
    "OffersDeleting": "Suppression...",
    "OffersDeleteCorrectionsButton": "🗑️ Supprimer les corrections",
    "OffersBulkDeleteProgress": "Suppression de {{count}} offres en cours...",
    "OffersBulkDeleteSelectPlaceholder": "-- Choisir un modèle --",
    "OffersNegativeIndicators": "Indicateurs Négatifs",
    "OffersSaveCorrectionsButton": "💾 Sauvegarder les corrections",
    "OffersAddDebugInfo": "Ajouter une information de debug",
    "OffersBusinessModelDefinition": "Définition du modèle économique",
    "OffersProductVision": "Vision produit",
    "OffersProductStrategyDefinition": "Définition de la stratégie produit",
    "OffersProductMarketingActivities": "Activités de marketing produit",
    "OffersGrowthActivities": "Activités de croissance",
    "OffersUserExperienceActivities": "Activités d'expérience utilisateur",
    "OffersDeliveryActivities": "Activités de livraison",
    "OffersDeliveryListedBeforeTacticsAndStrategy": "Livraison avant tactiques/stratégie",
    "OffersFeatureTeam": "Équipe fonctionnalité/marketing",
    "OffersTitleIsProductOwner": "Titre Product Owner",
    "OffersProductManagerWorksWithDistinctProductOwner": "PM avec PO distinct",
    "OffersUsesSAFe": "Utilise SAFe",
    "OffersCollaboratesWithDistinctBusinessTeam": "Collabore avec équipe business distincte",
    "OffersProductMarketingCustomerDiscovery": "Découverte client (Marketing Produit)",
    "OffersGrowthMarketingCustomerDiscovery": "Découverte client (Growth)",
    "OffersUXCustomerDiscovery": "Découverte client (UX)",
    "OffersContinuousDelivery": "Livraison continue",
    "OffersInternalProduct": "Produit interne",
    "OffersStrategicResponsibilities": "Responsabilités Stratégiques",
    "OffersTacticalAccountabilities": "Responsabilités Tactiques",
    "FineTuningLaunchDescription": "Sélectionnez un dataset de fine-tuning et lancez l'entraînement d'un nouveau modèle personnalisé. Le processus peut prendre plusieurs heures selon la taille du dataset.",
    "FineTuningSelectDatasetLabel": "Sélectionner un dataset :",
    "FineTuningLaunchButton": "🚀 Lancer le Fine-Tuning",
    "FineTuningLaunching": "🔄 Lancement en cours...",
    "FineTuningDeleteDescription": "Sélectionnez un dataset de fine-tuning à supprimer définitivement. Cette action est irréversible.",
    "FineTuningDeleteSelectLabel": "Sélectionner un dataset à supprimer :",
    "FineTuningSelectDatasetMessage": "Veuillez sélectionner un dataset pour le fine-tuning.",
    "FineTuningLaunchingMessage": "Lancement du fine-tuning en cours...",
    "AuthEmailPrompt": "Veuillez fournir votre email pour confirmer la connexion:",
    "AuthLinkSentMessage": "Lien de connexion envoyé ! Vérifiez votre email.",
    "AuthSending": "Envoi...",
    "AuthConnectButton": "Se connecter",
    "AuthEmailPlaceholder": "Votre email",
    "PrivacyPolicyLink": "Politique de confidentialité",
    "LegalNoticeLink": "Mentions légales",
    "TermsOfServiceLink": "CGU",
    "FaqLink": "FAQ",
    "AboutLink": "À propos",
    "ExtensionChromeLink": "Extension Chrome",
    "ResponsibleApplicationDirectLossCandidate": "Cette offre peu conforme coûte au candidat entre 160 000€ et 400 000€+ sur 10 ans",
    "ResponsibleApplicationDirectLossDetails": "en pertes salariales, promotions manquées, investissements de formation gaspillés et retards de progression de carrière.",
    "ResponsibleApplicationDirectLossState": "L'État perd quant à lui environ 985 000€",
    "ResponsibleApplicationDirectLossStateDetails": "en soutien direct, pertes fiscales, subventions de formation gaspillées et coûts sociaux par startup.",
    "ResponsibleApplicationGeneralLossCandidate": "Une offre peu conforme de Product Manager peut coûter aux candidats 160 000€ à 400 000€+ sur 10 ans",
    "ResponsibleApplicationGeneralLossDetails": "par des écarts salariaux, une progression de carrière bloquée et des investissements de formation gaspillés.",
    "ResponsibleApplicationGeneralLossState": "L'État peut perdre jusqu'à 985 000€ par startup",
    "ResponsibleApplicationGeneralLossStateDetails": "en soutien public, pertes fiscales, gaspillage de formation et productivité économique réduite.",
    "OurBigTechsContent": "Le marché de l'emploi dans l'innovation est devenu une foire à la surenchère où les titres modernes (Product Manager, UX Designer, etc.) cachent souvent des rôles traditionnels (Chef de projet, UI Designer, etc.). Cela affecte les travailleurs, entreprises et citoyens européens. Nous exigeons une standardisation des professions de l'innovation, un rating des entreprises, un ajustement des aides publiques et des sanctions pour les entreprises non conformes.",
    "OurBigTechsLinkText": "Likez l'article sur LinkedIn",
    "CalcNotDefined": "Non défini",
    "CalcNoMention": "Aucune mention",
    "CalcConsulted": "Consulté",
    "CalcResponsibleExecutes": "Responsable (exécute)",
    "CalcAccountableDecides": "Comptable (décide)",
    "CalcAccountableNotExecutes": "Comptable (décide mais n'exécute pas)",
    "CalcResponsibleNotDecides": "Responsable (exécute mais ne décide pas)",
    "CalcAccountableAndResponsible": "Comptable et responsable (décide et exécute)",
    "CalcCollaboratesWithProductMarketer": "Collabore directement avec un Product Marketer",
    "CalcAccountableWithProductMarketer": "Comptable (décide) et collabore directement avec un Product Marketer",
    "CalcCollaboratesWithGrowthManager": "Collabore directement avec un Growth Manager",
    "CalcAccountableWithGrowthManager": "Comptable (décide) et collabore directement avec un Growth Manager",
    "CalcCollaboratesWithUXDesigner": "Comptable (décide) et collabore avec un UX Designer",
    "CalcUnknownValue": "Valeur inconnue ({{value}})",
    "CalcStrategicResponsibilities": "Responsabilités stratégiques",
    "CalcTacticalAccountabilities": "Responsabilités tactiques",
    "CalcBusinessModelDefinition": "Définition du modèle économique :",
    "CalcProductStrategyDefinition": "Définition de la stratégie produit :",
    "CalcProductMarketingActivities": "Activités de marketing produit :",
    "CalcGrowthActivities": "Activités de growth marketing :",
    "CalcUXActivities": "Activités UX :",
    "CalcDeliveryActivities": "Activités de delivery :",
    "CalcNegativeIndicators": "Indicateurs négatifs",
    "CalcNone": "Aucun",
    "CalcNoData": "Aucune donnée",
    "CalcCustomerDiscoveryActivities": "Activités de découverte client",
    "CalcProductMarketingDiscovery": "Découverte client en marketing produit :",
    "CalcGrowthMarketingDiscovery": "Découverte client en growth marketing :",
    "CalcUXDiscovery": "Découverte client en UX :",
    "CalcContinuousDelivery": "Livraison continue :",
    "CalcMentionedPositioning": "Mentionnée",
    "CalcMentionedAcquisition": "Mentionnée",
    "CalcMentionedUX": "Mentionnée",
    "CalcMentionedFrequent": "Mentionnée",
    "CalcNotMentioned": "Non mentionnée",
    "CalcFinalScore": "Score final",
    "CalcWeighting": "Pondération :",
    "CalcNutriScoreScore": "Job-Nutriscore :",
    "CalcSmellDeliveryListedFirst": "Les activités de delivery sont listées avant les tactiques et la stratégie",
    "CalcSmellFeatureTeam": "Le Product Manager est responsable d'une fonctionnalité ou d'un aspect du produit, pas du produit complet",
    "CalcSmellTitleProductOwner": "Le titre du poste est Product Owner au lieu de Product Manager",
    "CalcSmellPMWithDistinctPO": "Le Product Manager travaille avec un Product Owner distinct",
    "CalcSmellUsesSAFe": "L'organisation utilise la méthodologie SAFe",
    "CalcSmellDistinctBusinessTeam": "Collaboration avec une équipe business distincte ou un Business Owner",
    "CalcSmellUserNeedsOverValue": "L'objectif est la satisfaction des besoins utilisateurs sans mention de la valeur économique",
    "CalcSmellManageMultipleProducts": "Le Product Manager gère plusieurs produits",
    "CalcSmellNoDistinctUXDesigner": "Aucun UX Designer distinct explicitement mentionné",
    "CalcSmellUXOptimization": "Focus sur l'optimisation UX plutôt que sur la découverte client et l'expérimentation",
    "CalcSmellProductMarketingOptimization": "Focus sur l'optimisation marketing produit plutôt que sur la découverte client et l'expérimentation",
    "CalcSmellGrowthOptimization": "Focus sur l'optimisation growth marketing plutôt que sur la découverte client et l'expérimentation",
    "CalcSmellFeatureDeliverySpeed": "Priorité à la vitesse de livraison des fonctionnalités plutôt qu'à la valeur business",
    "CalcSmellInternalProduct": "Tous les produits sont internes plutôt que destinés aux clients",
    "CalcDetailsTitle": "Critères de calcul",
    "CalcTooltipBusinessModelDefinition": "Attendu : Le PM définit ou influence significativement le business model.\nNiveaux : non mentionné, consulté, responsable (exécute), comptable (décide).",
    "CalcTooltipProductStrategyDefinition": "Attendu : Le PM définit ou influence significativement la stratégie produit.\nNiveaux : non mentionné, consulté, responsable (exécute), comptable (décide).",
    "CalcTooltipProductMarketingActivities": "Attendu : Activités incluant analyse de marché, positionnement, go-to-market.\nNiveaux : non mentionné, collabore avec un Product Marketer, comptable et collabore.",
    "CalcTooltipGrowthActivities": "Attendu : Activités liées à l'acquisition utilisateurs, tests de canaux.\nNiveaux : non mentionné, collabore avec un Growth Manager, comptable et collabore.",
    "CalcTooltipUXActivities": "Attendu : Recherche utilisateur, design UX, prototypage.\nNiveaux : non mentionné, comptable et collabore avec un UX Designer.",
    "CalcTooltipDeliveryActivities": "Attendu : Vision produit, stratégie produit, gestion de backlog, user stories.\nNiveaux : non mentionné, comptable (décide), responsable (exécute), comptable et responsable.",
    }
  }
};

i18n
  .use(LanguageDetector)  
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    //supportedLngs: ["en", "fr"],
    nonExplicitSupportedLngs: true,
    fallbackLng: "en",
    // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    },
    detection: {
      order: ['navigator']
    }
  });

  export default i18n;